module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Reply-52438e7bd2b6e519e73fa3d2656c6d13.svg";